import { render, staticRenderFns } from "./ChangeAppointmentStatus.vue?vue&type=template&id=76a74c7e"
import script from "./ChangeAppointmentStatus.vue?vue&type=script&lang=js"
export * from "./ChangeAppointmentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports